/**
 * Date Control Component
 * Renders date picker
 */

import React from 'react';
import { Box } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { DateSettings } from '../../../../types/ControlTypes';
import { BaseDateTimePicker } from '../BaseDateTimePicker';
import { LabelWithInfo } from './LabelWithInfo';

export const DateControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  description,
  required,
  control,
}) => {
  const settings = control.settings as DateSettings;
  const format = settings?.format || 'MM/dd/yyyy';

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ mb: 1 }}>
        <LabelWithInfo
          label={label || name}
          description={description}
          required={required}
        />
      </Box>
      <BaseDateTimePicker
        views={['year', 'month', 'day']}
        openTo="day"
        format={format}
        value={value ? dayjs(value) : null}
        onChange={(newValue: Dayjs | null) => {
          onChange(newValue ? newValue.format('YYYY-MM-DD') : null);
        }}
        disabled={disabled || readonly}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            error: !!error,
            helperText: error,
          },
        }}
      />
    </Box>
  );
};

export default DateControl;
